export const debugLogger = (...text: unknown[]) => {
  if (import.meta.env.DEV) {
    console.log(...text);
  }
};
